const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const Bundles = require("../Bundles");
const URLMake = require("../../../shared/URLMake");
const Derived = require("../vault/Derived");
const OpsUser = require("../vault/OpsUser");
const AT = require("../vault/ActionTypes");
const {
	atCurrResult,
	atCurrBlock,
	atCurrLabBlock,
} = require("../vault/StateCursors");
const TrainerCore = require("../../../shared/TrainerCore");

const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");

const Link = require("./Link");
const SwitchSetModal = require("./SwitchSetModal");
const AssetsUtil = require("../util/AssetsUtil");

const {FLAGS} = require("../util/GlobalFlags");

const styles = require("./styles/TeacherMenu.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(
		Component,
		(props, vaultState) => ({
			result: atCurrResult(vaultState).get(),
			block: atCurrBlock(vaultState).get(),
			labBlock: atCurrLabBlock(vaultState).get(),
			styleType: Derived.getCurrentModalStyle(vaultState),
		}),
		{forLoggedIn: true}
	);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "TeacherMenu",

		propTypes: {
			//Info from the vault that must be passed down from its parent
			user: PT.object.isRequired,
			page: PT.object.isRequired,

			// Injected by HOCs
			result: PT.object,
			block: PT.object,
			labBlock: PT.object,
			styleType: PT.string,
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				isOpen: false,
				isSwitchModalOpen: false,
				isRestartModalOpen: false,
			};
		},

		UNSAFE_componentWillReceiveProps: function(newProps) {
			const {result} = newProps;
			const OpsResult = Bundles.requireOpt("trainer", "OpsResult");
			if (!result || !OpsResult || !OpsResult.canRestartSet(result)) {
				this.setState({isRestartModalOpen: false});
			}
			if (!result || !OpsResult || !OpsResult.canSwitchSet(result)) {
				this.setState({isSwitchModalOpen: false});
			}
		},

		toggleOpen: function() {
			this.setState({isOpen: !this.state.isOpen});
		},

		onSwitchSet: function() {
			this.setState({isSwitchModalOpen: true, isRestartModalOpen: false});
		},

		onRestartSet: function() {
			this.setState({isSwitchModalOpen: false, isRestartModalOpen: true});
		},

		onGoToTestPart: function(newPart) {
			this.props.dispatch({
				type: AT.SWITCH_TO_TEST_PART,
				part: newPart,
			});
		},

		handleModalClose: function() {
			this.setState({isSwitchModalOpen: false, isRestartModalOpen: false});
		},

		handleRequestSet: function(options = {}) {
			const {
				isRestartSet = false,
				setNumber = null,
				originalSetID = null,
			} = options;
			this.props.dispatch({
				type: AT.REQUEST_SPECIFIC_SET,
				setNumber,
				originalSetID,
				forceResume: !isRestartSet,
				forceNewResult: isRestartSet,
			});
		},

		getButtons: function() {
			const {user, result} = this.props;
			const staffRoles = _.get(user, "model.staffRoles") || {};
			const buttons = [];

			const OpsResult = Bundles.requireOpt("trainer", "OpsResult");
			if (result && OpsResult) {
				if (OpsResult.canRestartSet(result)) {
					buttons.push(
						<div
							onClick={this.onRestartSet}
							className={styles.button}
							key="restart"
						>
							{"Restart Problem Set"}
						</div>
					);
				}
				if (OpsResult.canSwitchSet(result)) {
					buttons.push(
						<div
							onClick={this.onSwitchSet}
							className={styles.button}
							key="switch"
						>
							{"Switch Problem Set"}
						</div>
					);
				}
				const resultType = _.get(result, "resultType");
				if (
					resultType === "test" ||
					(resultType === "bookTest" && !result.isComplete)
				) {
					const currentTestPart = _.includes(
						TrainerCore.getProblemRangeForTestPart(result, 2),
						result.currentProblemIndex
					)
						? 2
						: 1;
					const newPart = currentTestPart === 1 ? 2 : 1;
					if (this.props.page.problemIndex !== "summary")
						buttons.push(
							<div
								onClick={() => this.onGoToTestPart(newPart)}
								className={styles.button}
								key="switchtestpart"
							>
								{"Switch To Part " + newPart}
							</div>
						);
				}
			}

			if (OpsUser.hasKey(user, "admin view") && FLAGS.showAdminLinks) {
				buttons.push(
					<Link
						to="/admin"
						className={styles.button}
						key="admin"
						isExternal={true}
						useWonkyCursor={true}
					>
						{"Admin"}
					</Link>
				);
				buttons.push(
					<Link
						to={URLMake.forOffice()}
						className={styles.button}
						key="home"
						useWonkyCursor={true}
					>
						{"Main Site"}
					</Link>
				);
			}

			const shouldViewReports =
				OpsUser.hasKey(user, "teacher") ||
				staffRoles.adminPurchase ||
				!_.isEmpty(staffRoles.teachClassIDs) ||
				!_.isEmpty(staffRoles.adminSchoolIDs);

			if (shouldViewReports) {
				buttons.push(
					<Link
						to={URLMake.forSchool()}
						className={styles.button}
						key="reports"
						useWonkyCursor={true}
						newTab={true}
					>
						{"Reports"}
					</Link>
				);
			} else {
				buttons.push(
					<Link
						to={URLMake.forParent()}
						className={styles.button}
						key="students"
						useWonkyCursor={true}
					>
						{"Reports"}
					</Link>
				);
			}

			return buttons;
		},

		render: function() {
			const {user, block, labBlock, result, styleType, page} = this.props;
			if (
				!OpsUser.isLoggedIn(user) ||
				!OpsUser.hasKey(user, "trainer can view teacher menu") ||
				page.demo
			) {
				return null;
			}

			let modal = null;
			if (this.state.isSwitchModalOpen || this.state.isRestartModalOpen) {
				modal = (
					<SwitchSetModal
						onClose={this.handleModalClose}
						result={result}
						block={block}
						labBlock={labBlock}
						styleType={styleType}
						isRestartSet={this.state.isRestartModalOpen}
						onRequestSet={this.handleRequestSet}
					/>
				);
			}

			const mainClass =
				styles.main + " " + (this.state.isOpen ? styles.open : styles.closed);

			return (
				<div
					className={mainClass}
					style={FLAGS.cleanMode ? {display: "none"} : {}}
				>
					<div className={styles.circle} onClick={this.toggleOpen}>
						<img
							className={styles.icon}
							src={AssetsUtil.getButton("teacher-blue")}
						/>
						<img
							className={styles.arrow}
							src={AssetsUtil.getButton("down-blue")}
						/>
					</div>
					<div className={styles.hover} onClick={this.toggleOpen}>
						<img
							className={styles.icon}
							src={AssetsUtil.getButton("teacher-cyan")}
						/>
						<img
							className={styles.arrow}
							src={AssetsUtil.getButton("down-cyan")}
						/>
					</div>
					<div className={styles.connector}>
						<div className={styles.connectorShadow} />
					</div>
					<div className={styles.menu}>
						<div className={styles.buttonList}>{this.getButtons()}</div>
					</div>
					{modal}
				</div>
			);
		},
	})
);
